/**
 * Hero video and related public assets — same-origin URLs only (no cross-origin media URLs).
 * Honors CRA/Capacitor PUBLIC_URL when the app is hosted under a subpath.
 */
export function getPublicAssetUrl(pathname: string): string {
  const base = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
  const segment = pathname.startsWith('/') ? pathname : `/${pathname}`;
  return `${base}${segment}`;
}

export function getHeroVideoSrc(): string | null {
  return null; // Disable default video to clear old branding
}

/**
 * Stored in DB when the admin disables the home hero video.
 * Distinct from missing setting (null) → site still uses bundled `/video.mp4`.
 */
export const HERO_VIDEO_DISABLED_MARKER = '__HERO_VIDEO_DISABLED__';

/**
 * URL for `<video src>` on the home hero.
 * - Custom URL from settings → use it
 * - {@link HERO_VIDEO_DISABLED_MARKER} → no video (background + text only)
 * - null / undefined from API (never set) → bundled default `getHeroVideoSrc()`
 */
export function getHeroVideoUrlForPlayback(heroVideoUrlFromApi: string | null | undefined): string | null {
  if (heroVideoUrlFromApi === HERO_VIDEO_DISABLED_MARKER) return null;
  const trimmed = typeof heroVideoUrlFromApi === 'string' ? heroVideoUrlFromApi.trim() : '';
  if (trimmed) return trimmed;
  return getHeroVideoSrc();
}

export function getHeroBackgroundImageSrc(): string {
  // Use a generic SVG gradient or solid color to replace the old background.jpeg
  return `data:image/svg+xml;charset=UTF-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1200' height='400' viewBox='0 0 1200 400'%3E%3Crect width='1200' height='400' fill='%230f172a'/%3E%3C/svg%3E`;
}

export function isHeroMediaImage(url: string | null | undefined): boolean {
  if (!url) return false;
  return /\.(jpeg|jpg|png|webp|gif|svg)$/i.test(url.split('?')[0]);
}
